import React from 'react'
import { Card, Text } from 'theme-ui'
import Section from '@components/Section'

const Commitment = props => (
  <Section aside title='Our promise' {...props}>
    <Card variant='paper'>
      <Text variant='p'>
          Any enquiry on your part is non-binding and will be answered with the utmost dedication as well. We accompany you with care on your way to your personal treatment and journey, how and when you desire.
      </Text>
    </Card>
  </Section>
)

export default Commitment
